/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Warning/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Warning({
  children,
  viewPath = "/DesignSystem/Svgs/Warning",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Warning.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-Z1LKkp9': alignSelf,'--mt-2-Z1LKkp9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1LKkp9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1LKkp9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1LKkp9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1LKkp9': opacity,'--w-7-Z1LKkp9': typeof width === 'number' ? `${width}px` : width,'--h-8-Z1LKkp9': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Warning.SvgPath"
  data-view-path={viewPath}
 strokeMiterlimit={10}
 d="M13.3 14.1H2.7c-.6 0-1.1-.3-1.3-.8-.3-.5-.3-1.1 0-1.6l5.3-9.2c.2-.4.7-.6 1.3-.6h0c.6 0 1.1.3 1.3.8l5.3 9.2c.3.5.3 1.1 0 1.6s-.7.6-1.3.6z"
 style={{'--f-9-Z1LKkp9': fill,'--s-10-Z1LKkp9': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Warning.SvgPath:1"
  data-view-path={viewPath}
 strokeLinecap="round"
 strokeMiterlimit={10}
 d="M8 4.8v4.6M8 11.5v.5"
 style={{'--f-9-Z1LKkp9': fill,'--s-10-Z1LKkp9': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}